import React, { useState, useEffect, useContext } from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AddIcon from '@material-ui/icons/Add';

import withWidth from '@material-ui/core/withWidth';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';


import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

import { DatePicker, TimePicker } from '../components/DatePicker';

import { API } from 'aws-amplify';
import LoadingButton, { LoadingSuccessButton } from '../components/LoadingButton';
import LoadingDialog from './LoadingDialog';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(0, 1),
    overflowY: 'hidden'
  },
  paperContent: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  iconRight: {
    position: 'absolute',
    right: '0px'
  },
  saveButton: {
    margin: theme.spacing (1),
  },
  datePicker: {
    width: '100%'
  }
}))

const day = 1000 * 60 * 60 * 24;


const todayTime = (h, m) => {
  const date = new Date;
  date.setHours (h, m, 0, 0);
  return date;
}

const Picker = () => {
  const classes = useStyles();
  const [initialized, setInitialized] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [entries, setEntries] = useState({
    1: [], 2:[], 3:[], 4:[], 5:[], 6:[], 0:[]
  })

  useEffect (() => {
    if (!initialized)
    (async() => {
      const res = await API.get ('appointments', '/openingHours');
      setInitialized(true);
      setEntries(res);
    })()
  })
  const onAdd = (data) => {
    setEntries ({
      ...entries,
      [data.day]: [
        ...(entries[data.day]||[]),
        data
      ]
    });
    setSuccess(false)
  }

  const onDelete = (entry) => {
    const ent = entries[entry.day];
    const ind = ent.indexOf (entry);
    ent.splice (ind, 1);
    setEntries ({
      ...entries,
      [entry.day]: ent
    });
    setSuccess(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const res = await API.post ('appointments', '/openingHours', {
      body: entries
    })
    setSuccess(true);
    setLoading(false)
  }
    if (!initialized) {
      return <LoadingDialog>Öffnungszeiten werden geladen</LoadingDialog>
    }
    return <form onSubmit={handleSubmit}>
      <Grid container item xs={12} justify="center" spacing={1}>{
        Object.keys(entries).map ((day, i) => {
            return <DayEntry day={day} onAdd={onAdd} handleDelete={onDelete} entries={entries[day]||[]}></DayEntry>
        })}
      </Grid>
      <center>
        <LoadingButton 
          color="primary"
          variant="contained"
          isLoading={isLoading}
          disabled={success}
          className={classes.saveButton}
          type="submit"
        >{success?'Gespeichert':'Speichern'}</LoadingButton>
      </center>
    </form>
}

const options = { weekday: 'short', month: 'numeric', day: 'numeric' };

const days = {
  1: 'Mo.',
  2: 'Di.',
  3: 'Mi.',
  4: 'Do.',
  5: 'Fr.',
  6: 'Sa.',
  0: 'So.'
}
const LoadingEntry = (props) => {
  const classes = useStyles();
  const { day, entries = [], onAdd, handleDelete } = props
  const header = days [day];

  return <Grid item>
    <Paper className={classes.paper}>
      <Typography variant="h5">{header}</Typography>
      <hr></hr>
      <div className={classes.paperContent}>
        <Grid container direction="column" spacing={1}>
           <Grid item>
              <center>
                <Chip 
                  label={`Loading`}
                ></Chip>
              </center>
            </Grid>
            <Grid item>
            <center>
              <IconButton><AddIcon></AddIcon></IconButton>
            </center>
          </Grid>
          </Grid>
      </div>
    </Paper>
  </Grid>
}

const DayEntry = (props) => {
  const classes = useStyles();
  const { day, entries = [], onAdd, handleDelete } = props
  const header = days [day];
  const [ open, setOpen ] = useState(false);

  const openDialog = () => {
    setOpen(true);
  }

  const handleAdd = (data) => {
    setOpen (false);
    onAdd (data)
  }
  
  const handleClose = () => {
    setOpen(false)
  }

  return <Grid item>
    <Paper className={classes.paper}>
      <Typography variant="h5">{header}</Typography>
      <hr></hr>
      <div className={classes.paperContent}>
        <Grid container direction="column" spacing={1}>
          {entries.map ((ts) => {
            const fromD = new Date (ts.from);
            const toD = new Date (ts.to);
            const timStrFrom = fromD.toTimeString().split (":").slice (0,2).join(':')
            const timStrTo = toD.toTimeString().split (":").slice (0,2).join(':')
            return <Grid item>
              <center>
                <Chip 
                  label={`${timStrFrom}-${timStrTo}`}
                  onDelete={() => {
                    handleDelete(ts)
                  }}
                ></Chip>
              </center>
            </Grid>
          })}
          <Grid item>
            <center>
              <IconButton onClick={openDialog}><AddIcon></AddIcon></IconButton>
            </center>
          </Grid>
        </Grid>
      </div>
    </Paper>
    <TimePickerDialog handleClose={handleClose} open={open} onAdd={handleAdd} day={day}></TimePickerDialog>
  </Grid>
}

const TimePickerDialog = (props) => {
  const { open, onAdd, day, handleClose} = props;
  return <Dialog open={open} onClose={handleClose}>
    <AppointmentForm onAdd={onAdd} day={day}></AppointmentForm>
  </Dialog>
}

const AppointmentForm = (props) => {
  const classes = useStyles();
  const [ fromDate, setFrom ] = useState(new Date(todayTime(8, 0)));
  const [ toDate, setTo ] = useState(new Date(todayTime(12, 0)));
  const { onAdd, day} = props;

  const handleSubmit = (e) => {
    e.preventDefault()
    if (typeof onAdd === 'function') {
      onAdd ({
        from: +fromDate,
        to: +toDate,
        day
      })
    }
  }

  return <Card className={classes.card}>
        <CardContent>
          <Grid container justify="space-between" spacing={1}>
          <TimePicker className={classes.datePicker} label="Von" value={fromDate} onChange={setFrom} />
          <TimePicker className={classes.datePicker} label="Bis" value={toDate} onChange={setTo} />
          </Grid>
        </CardContent>
        <CardActions>
          <Button variant="contained" color="primary" type="submit" onClick={handleSubmit}>Hinzufügen</Button>
        </CardActions>
      </Card>
}
export default Picker;